<template>
  <div class="collects-wrapper">
    <BasisNav
      support-search
      nav-title="我的收藏"
      :back="back"
    />
    <van-tabs v-model="activeTab" sticky>
      <van-tab v-if="organization.moduleFonts.enable" :title="organization.moduleFonts.title" name="characters">
        <basis-list-wrapper
          target-key="stars-characters"
          :extra-keys="characterKeys"
        >
          <template v-slot:item="{item}">
            <van-row
              class="character-wrapper"
              type="flex"
              align="center"
              @click="clickHandler({
                name: 'character-id',
                params: {
                  id: item.id,
                  courseId: item.course.id,
                  teacherId: item.course.teacher.id
                },
                query: {
                  return_to_url: $route.fullPath
                }
              })"
            >
              <van-col class="character-img-box">
                <van-image
                  width="80px"
                  height="80px"
                  fit="contain"
                  :src="item.cover"
                />
              </van-col>
              <van-col class="info">
                <p class="title">{{ item.course.name }}</p>
                <p class="teacher">{{ item.course.teacher.name }}</p>
              </van-col>
              <van-icon name="arrow" />
            </van-row>
          </template>
        </basis-list-wrapper>
      </van-tab>
      <van-tab v-if="organization.moduleNews.enable" :title="organization.moduleNews.title" name="videos">
        <basis-list-wrapper
          target-key="stars-videos"
          :extra-keys="videoKeys"
        >
          <template v-slot:item="{item}">
            <van-row
              class="video-wrapper"
              @click="clickHandler({
                name: 'video-id',
                params: {
                  id: item.id,
                  teacherId: item.teacher.id,
                },
                query: {
                  return_to_url: $route.fullPath
                }
              })"
            >
              <van-col class="video-img-box">
                <van-image
                  width="100%"
                  height="193px"
                  fit="contain"
                  :src="item.cover"
                />
              </van-col>
              <van-col class="info">
                <p class="title">{{ item.title }}</p>
                <span class="date">{{ item.createdAt | dateFormat }}</span>
              </van-col>
            </van-row>
          </template>
        </basis-list-wrapper>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { BasisNav, BasisListWrapper } from '@/components/basis'
import { mixinWxShare } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'Collects',
  components: { BasisNav, BasisListWrapper },
  mixins: [mixinWxShare],
  data: () => ({
    activeTab: 'characters',
    characterKeys: {
      collection: 'characters'
    },
    videoKeys: {
      collection: 'videos'
    }
  }),
  computed: {
    ...mapGetters(['organization'])
  },
  methods: {
    back () {
      this.$router.push({ name: 'studio-user' })
    },
    clickHandler (target) {
      this.$router.push(target)
    }
  }
}
</script>

<style scoped lang="scss">
.collects-wrapper {
  @include mh-bgc(100vh, $color-bg);
  .van-tabs {
    ::v-deep {
      .van-tabs__wrap {
        border-radius: 0 0 8px 8px;
        &[class*='van-hairline']::after {
          display: none;
        }
        .van-tabs__line {
          @include wh(32px !important, 4px);
          @include lg-radius(#E6AC67, #F5C993);
          bottom: 20px;
          background-color: $color-text-active;
        }
      }
    }
    .character-wrapper, .video-wrapper {
      margin-top: 16px;
      padding: 16px;
      border-radius: 8px;
      background-color: #fff;
    }
    .character-wrapper {
      .character-img-box {
        font-size: 0;
      }
      .info {
        @include wh(227px, inherit);
        @include sc($font-size-lg, $color-text-heavy);
        @include lw(23px, 500);
        padding: 4px 12px 8px 9px;
        .title {
          @include sc($font-size-lg, $color-text-heavy);
          @include ellipsis(2, 23px);
          @include wh(100%, 46px);
          margin-bottom: 8px;
        }
        .teacher {
          @include sc($font-size-base, $color-text-light);
        }
      }
    }
    .video-wrapper {
      .video-img-box {
        font-size: 0;
      }
      .info {
        padding-top: 12px;
        .title {
          @include sc($font-size-lg, $color-text-heavy);
          @include lw(23px, 500);
          @include ellipsis(2, 23px);
          padding-bottom: 4px;
        }
        .date {
          @include sc($font-size-base, $color-text-light);
        }
      }
    }
  }
}
</style>
